import { render, staticRenderFns } from "./TotalMentalHealthStart.vue?vue&type=template&id=568450d9"
import script from "./TotalMentalHealthStart.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthStart.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthStart.vue?vue&type=style&index=0&id=568450d9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports